import React from "react";
import { Link } from "react-router-dom";

const Page404 = () => {
  return (
    <>
      <div className="container" style={{ padding: "6rem 1rem", textAlign: "center" }}>
        <h1 className="sobre-nosotras-title">Página no encontrada</h1>
        <p className="mitexto">La página que buscas no existe.</p>
        <Link to="/">
          <button className="contact-button">Volver al inicio</button>
        </Link>
      </div>
    </>
  );
};

export default Page404;
